import type { FC, SVGAttributes } from "react";

export const SelectCampaignIcon: FC<SVGAttributes<SVGElement>> = ({ width = "156", height = "93", ...rest }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 156 93"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <g filter="url(#filter0_d_6002_17730)">
            <rect
                x="15.4805"
                y="25.9829"
                width="77.9142"
                height="62.3448"
                rx="3.0556"
                fill="#FFFEFE"
            />
        </g>
        <g filter="url(#filter1_d_6002_17730)">
            <path
                d="M15.4805 29.0385C15.4805 27.3509 16.8485 25.9829 18.5361 25.9829H90.339C92.0266 25.9829 93.3946 27.3509 93.3946 29.0385V33.3305H15.4805V29.0385Z"
                fill="url(#paint0_linear_6002_17730)"
                fillOpacity="0.3"
            />
        </g>
        <g opacity="0.5">
            <path
                d="M23.6113 54.0996C23.6113 51.8379 25.4448 50.0044 27.7065 50.0044C29.9682 50.0044 31.8017 51.8379 31.8017 54.0996L31.8017 81.064C31.8017 81.0941 31.7773 81.1185 31.7472 81.1185L23.6658 81.1185C23.6357 81.1185 23.6113 81.0941 23.6113 81.064L23.6113 54.0996Z"
                fill="url(#paint1_linear_6002_17730)"
                fillOpacity="0.3"
            />
            <path
                d="M35.6934 61.1372C35.6934 58.8755 37.5268 57.042 39.7885 57.042C42.0503 57.042 43.8837 58.8755 43.8837 61.1372L43.8837 81.0805C43.8837 81.1009 43.8672 81.1174 43.8467 81.1174L35.7303 81.1174C35.7099 81.1174 35.6934 81.1009 35.6934 81.0805L35.6934 61.1372Z"
                fill="url(#paint2_linear_6002_17730)"
                fillOpacity="0.3"
            />
            <path
                d="M47.7734 70.249C47.7734 67.9873 49.6069 66.1538 51.8686 66.1538C54.1303 66.1538 55.9638 67.9873 55.9638 70.249L55.9638 81.1013C55.9638 81.1106 55.9563 81.1181 55.947 81.1181L47.7902 81.1181C47.781 81.1181 47.7734 81.1106 47.7734 81.1013L47.7734 70.249Z"
                fill="url(#paint3_linear_6002_17730)"
                fillOpacity="0.3"
            />
        </g>
        <g filter="url(#filter2_d_6002_17730)">
            <rect
                x="62.6055"
                y="6.5"
                width="77.9142"
                height="55.8506"
                rx="3.0556"
                fill="#FFFEFE"
            />
        </g>
        <rect
            x="70.2969"
            y="20.7188"
            width="31.4733"
            height="32.5294"
            rx="1.5278"
            fill="url(#paint4_linear_6002_17730)"
            fillOpacity="0.3"
        />
        <ellipse
            cx="79.2696"
            cy="30.0783"
            rx="3.72855"
            ry="3.85367"
            fill="url(#paint5_linear_6002_17730)"
        />
        <path
            d="M90.7056 35.5169C91.3141 34.8245 92.3925 34.8245 93.0009 35.5169L109.367 54.1404H74.3398L90.7056 35.5169Z"
            fill="url(#paint6_linear_6002_17730)"
        />
        <path
            d="M78.3429 40.3484C78.9513 39.6561 80.0297 39.6561 80.6382 40.3484L92.7584 54.1407H66.2227L78.3429 40.3484Z"
            fill="url(#paint7_linear_6002_17730)"
        />
        <rect
            x="107.385"
            y="20.7188"
            width="27.2141"
            height="3.82729"
            rx="1.91364"
            fill="url(#paint8_linear_6002_17730)"
            fillOpacity="0.3"
        />
        <rect
            opacity="0.4"
            x="112.205"
            y="42.6069"
            width="24.9112"
            height="1.56915"
            rx="0.784575"
            fill="url(#paint9_linear_6002_17730)"
            fillOpacity="0.3"
        />
        <rect
            opacity="0.4"
            x="23.6113"
            y="39.936"
            width="24.9112"
            height="1.56915"
            rx="0.784573"
            fill="url(#paint10_linear_6002_17730)"
            fillOpacity="0.3"
        />
        <rect
            opacity="0.4"
            x="107.385"
            y="48.7344"
            width="29.7302"
            height="1.56915"
            rx="0.784575"
            fill="url(#paint11_linear_6002_17730)"
            fillOpacity="0.3"
        />
        <rect
            x="107.385"
            y="27.8457"
            width="16.3905"
            height="3.82729"
            rx="1.91364"
            fill="url(#paint12_linear_6002_17730)"
            fillOpacity="0.3"
        />
        <rect
            opacity="0.4"
            x="112.205"
            y="45.6709"
            width="24.9112"
            height="1.56915"
            rx="0.784573"
            fill="url(#paint13_linear_6002_17730)"
            fillOpacity="0.3"
        />
        <rect
            opacity="0.4"
            x="23.6113"
            y="43.0005"
            width="14.6807"
            height="1.56915"
            rx="0.784573"
            fill="url(#paint14_linear_6002_17730)"
            fillOpacity="0.3"
        />
        <rect
            opacity="0.4"
            x="107.385"
            y="51.7983"
            width="19.6844"
            height="1.56915"
            rx="0.784573"
            fill="url(#paint15_linear_6002_17730)"
            fillOpacity="0.3"
        />
        <g filter="url(#filter3_d_6002_17730)">
            <path
                d="M62.6055 9.5556C62.6055 7.86804 63.9735 6.5 65.6611 6.5H137.464C139.152 6.5 140.52 7.86804 140.52 9.5556V13.8476H62.6055V9.5556Z"
                fill="url(#paint16_linear_6002_17730)"
                fillOpacity="0.3"
            />
        </g>
        <path
            opacity="0.6"
            d="M105.275 73.5955C104.569 73.4121 103.928 74.0705 104.106 74.7963L107.399 88.1916C107.582 88.9357 108.485 89.1912 109.013 88.6486L111.511 86.0812C111.887 85.695 112.496 85.695 112.871 86.0812L117.213 90.5428C117.589 90.9289 118.198 90.9289 118.573 90.5428L120.597 88.4636C120.972 88.0775 120.972 87.4514 120.597 87.0653L116.255 82.6037C115.879 82.2176 115.879 81.5915 116.255 81.2054L118.754 78.6379C119.282 78.0953 119.033 77.1682 118.309 76.9802L105.275 73.5955Z"
            fill="url(#paint17_linear_6002_17730)"
            fillOpacity="0.3"
        />
        <ellipse
            cx="68.9786"
            cy="9.98143"
            rx="1.32043"
            ry="1.36473"
            fill="white"
        />
        <ellipse
            cx="21.6075"
            cy="29.8237"
            rx="1.32043"
            ry="1.36473"
            fill="white"
        />
        <ellipse
            cx="73.6857"
            cy="9.98143"
            rx="1.32042"
            ry="1.36473"
            fill="white"
        />
        <ellipse
            cx="26.3165"
            cy="29.8237"
            rx="1.32043"
            ry="1.36473"
            fill="white"
        />
        <ellipse
            cx="78.3946"
            cy="9.98143"
            rx="1.32043"
            ry="1.36473"
            fill="white"
        />
        <ellipse
            cx="31.0255"
            cy="29.8237"
            rx="1.32043"
            ry="1.36473"
            fill="white"
        />
        <defs>
            <filter
                id="filter0_d_6002_17730"
                x="11.4805"
                y="21.9829"
                width="85.9141"
                height="70.3447"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood
                    floodOpacity="0"
                    result="BackgroundImageFix"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.129412 0 0 0 0 0.376471 0 0 0 0 0.980392 0 0 0 0.08 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6002_17730"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6002_17730"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_d_6002_17730"
                x="-15.0755"
                y="-4.57309"
                width="139.026"
                height="68.4597"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood
                    floodOpacity="0"
                    result="BackgroundImageFix"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="15.278" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.129412 0 0 0 0 0.376471 0 0 0 0 0.980392 0 0 0 0.15 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6002_17730"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6002_17730"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_d_6002_17730"
                x="58.6055"
                y="2.5"
                width="85.9141"
                height="63.8506"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood
                    floodOpacity="0"
                    result="BackgroundImageFix"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.129412 0 0 0 0 0.376471 0 0 0 0 0.980392 0 0 0 0.08 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6002_17730"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6002_17730"
                    result="shape"
                />
            </filter>
            <filter
                id="filter3_d_6002_17730"
                x="32.0495"
                y="-24.056"
                width="139.026"
                height="68.4597"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood
                    floodOpacity="0"
                    result="BackgroundImageFix"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="15.278" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.129412 0 0 0 0 0.376471 0 0 0 0 0.980392 0 0 0 0.15 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6002_17730"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6002_17730"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_6002_17730"
                x1="13.74"
                y1="33.3305"
                x2="93.3946"
                y2="33.3305"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#195AFE" />
                <stop
                    offset="1"
                    stopColor="#195AFE"
                    stopOpacity="0.4"
                />
            </linearGradient>
            <linearGradient
                id="paint1_linear_6002_17730"
                x1="27.7065"
                y1="50.0044"
                x2="27.7065"
                y2="81.1185"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#195AFE" />
                <stop
                    offset="1"
                    stopColor="white"
                />
            </linearGradient>
            <linearGradient
                id="paint2_linear_6002_17730"
                x1="39.7885"
                y1="57.042"
                x2="39.7885"
                y2="81.1174"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#195AFE" />
                <stop
                    offset="1"
                    stopColor="white"
                />
            </linearGradient>
            <linearGradient
                id="paint3_linear_6002_17730"
                x1="51.8686"
                y1="66.1538"
                x2="51.8686"
                y2="81.1181"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#195AFE" />
                <stop
                    offset="1"
                    stopColor="white"
                />
            </linearGradient>
            <linearGradient
                id="paint4_linear_6002_17730"
                x1="74.8222"
                y1="23.5989"
                x2="102.911"
                y2="40.787"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#195AFE" />
                <stop
                    offset="0.923629"
                    stopColor="#195AFE"
                    stopOpacity="0.42"
                />
            </linearGradient>
            <linearGradient
                id="paint5_linear_6002_17730"
                x1="82.0032"
                y1="27.1939"
                x2="76.0476"
                y2="33.488"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" />
                <stop
                    offset="1"
                    stopColor="white"
                    stopOpacity="0.45"
                />
            </linearGradient>
            <linearGradient
                id="paint6_linear_6002_17730"
                x1="91.8533"
                y1="34.2109"
                x2="91.8533"
                y2="54.1404"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" />
                <stop
                    offset="1"
                    stopColor="white"
                    stopOpacity="0"
                />
            </linearGradient>
            <linearGradient
                id="paint7_linear_6002_17730"
                x1="79.4905"
                y1="39.0425"
                x2="79.4905"
                y2="54.1407"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" />
                <stop
                    offset="1"
                    stopColor="white"
                    stopOpacity="0"
                />
            </linearGradient>
            <linearGradient
                id="paint8_linear_6002_17730"
                x1="131.512"
                y1="20.7188"
                x2="108.459"
                y2="20.7187"
                gradientUnits="userSpaceOnUse"
            >
                <stop
                    stopColor="#195AFE"
                    stopOpacity="0.1"
                />
                <stop
                    offset="1"
                    stopColor="#195AFE"
                    stopOpacity="0.5"
                />
            </linearGradient>
            <linearGradient
                id="paint9_linear_6002_17730"
                x1="134.29"
                y1="42.6069"
                x2="113.188"
                y2="42.6069"
                gradientUnits="userSpaceOnUse"
            >
                <stop
                    stopColor="#195AFE"
                    stopOpacity="0.1"
                />
                <stop
                    offset="1"
                    stopColor="#195AFE"
                    stopOpacity="0.5"
                />
            </linearGradient>
            <linearGradient
                id="paint10_linear_6002_17730"
                x1="45.6965"
                y1="39.936"
                x2="24.5944"
                y2="39.936"
                gradientUnits="userSpaceOnUse"
            >
                <stop
                    stopColor="#195AFE"
                    stopOpacity="0.1"
                />
                <stop
                    offset="1"
                    stopColor="#195AFE"
                    stopOpacity="0.5"
                />
            </linearGradient>
            <linearGradient
                id="paint11_linear_6002_17730"
                x1="133.742"
                y1="48.7344"
                x2="108.558"
                y2="48.7344"
                gradientUnits="userSpaceOnUse"
            >
                <stop
                    stopColor="#195AFE"
                    stopOpacity="0.1"
                />
                <stop
                    offset="1"
                    stopColor="#195AFE"
                    stopOpacity="0.5"
                />
            </linearGradient>
            <linearGradient
                id="paint12_linear_6002_17730"
                x1="121.916"
                y1="27.8457"
                x2="108.032"
                y2="27.8457"
                gradientUnits="userSpaceOnUse"
            >
                <stop
                    stopColor="#195AFE"
                    stopOpacity="0.1"
                />
                <stop
                    offset="1"
                    stopColor="#195AFE"
                    stopOpacity="0.5"
                />
            </linearGradient>
            <linearGradient
                id="paint13_linear_6002_17730"
                x1="134.29"
                y1="45.6709"
                x2="113.188"
                y2="45.6709"
                gradientUnits="userSpaceOnUse"
            >
                <stop
                    stopColor="#195AFE"
                    stopOpacity="0.1"
                />
                <stop
                    offset="1"
                    stopColor="#195AFE"
                    stopOpacity="0.5"
                />
            </linearGradient>
            <linearGradient
                id="paint14_linear_6002_17730"
                x1="36.6266"
                y1="43.0005"
                x2="24.1906"
                y2="43.0005"
                gradientUnits="userSpaceOnUse"
            >
                <stop
                    stopColor="#195AFE"
                    stopOpacity="0.1"
                />
                <stop
                    offset="1"
                    stopColor="#195AFE"
                    stopOpacity="0.5"
                />
            </linearGradient>
            <linearGradient
                id="paint15_linear_6002_17730"
                x1="124.836"
                y1="51.7983"
                x2="108.162"
                y2="51.7983"
                gradientUnits="userSpaceOnUse"
            >
                <stop
                    stopColor="#195AFE"
                    stopOpacity="0.1"
                />
                <stop
                    offset="1"
                    stopColor="#195AFE"
                    stopOpacity="0.5"
                />
            </linearGradient>
            <linearGradient
                id="paint16_linear_6002_17730"
                x1="60.865"
                y1="13.8476"
                x2="140.52"
                y2="13.8476"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#195AFE" />
                <stop
                    offset="1"
                    stopColor="#195AFE"
                    stopOpacity="0.4"
                />
            </linearGradient>
            <linearGradient
                id="paint17_linear_6002_17730"
                x1="105.11"
                y1="74.6278"
                x2="119.98"
                y2="89.097"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#195AFE" />
                <stop
                    offset="1"
                    stopColor="#195AFE"
                    stopOpacity="0.2"
                />
            </linearGradient>
        </defs>
    </svg>
);
